import { registerComponent } from '@gig/magic-common';
import { default as ContentToggleComponent } from './content-toggle.vue?shadowMode';

registerComponent(ContentToggleComponent, false);
